import { render, staticRenderFns } from "./Pipe.vue?vue&type=template&id=525a5116&scoped=true&"
import script from "./Pipe.vue?vue&type=script&lang=js&"
export * from "./Pipe.vue?vue&type=script&lang=js&"
import style0 from "./Pipe.vue?vue&type=style&index=0&id=525a5116&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525a5116",
  null
  
)

export default component.exports